import { render, staticRenderFns } from "./pubCertCompany.vue?vue&type=template&id=65c29c90"
import script from "./pubCertCompany.vue?vue&type=script&lang=js"
export * from "./pubCertCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports